import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { message, notification } from 'antd';
import { UIMessage, NewVersionNotification } from 'Common/notifications';

const MessageDisplayer = () => {
  const intl = useIntl();
  useEffect(() => {
    const subscription = UIMessage.subscribe(({ topic, data }) => {
      const msg = intl.formatMessage(
        data.message,
        data.messageOptions?.values || {}
      );
      const options = data.messageOptions;
      if (message[topic]) {
        return message[topic]({ ...options, content: msg });
      }
      return message.info(msg);
    });

    return () => subscription.unsubscribe();
  }, [intl]);

  useEffect(() => {
    const subscription = NewVersionNotification.subscribe(() => {
      notification.info({
        duration: 8,
        message: intl.formatMessage({
          defaultMessage: 'New version available',
        }),
        description: intl.formatMessage({
          defaultMessage: 'Please refresh the page to get the new content',
        }),
      });
    });

    return () => subscription.unsubscribe();
  }, [intl]);

  return null;
};

export default MessageDisplayer;
